import { DIALOG_TYPES, LetterDialogTypes } from 'countable@helpers';
import { AddCategory } from '../helpers/addSection.constants';
import { AddLetterModel, LetterSectionModel, SignatureLetterModel } from './eng/letter-section.model';
import { ComponentConfigModel } from './template/letter-s3.model';
import { UserTimeZoneModel } from './user-timezone.model';

export class DialogInputModel {
    data: any;
    dialogType: DIALOG_TYPES;
    dialogHeader: string;
    dialogBody?: string;
    dialogButtons?: any[];
    originId?: any;
    resendButton?: boolean;
    clientKey?: string;
    type?: AddCategory;
}

export class DialogResponseModel {
    executeAction:boolean = false;
    executeActionType: DIALOG_TYPES;
    responseData: any;
}

export class TemplateDialogModel {
  firmTemplates: any;
  masterLibrary: any;
  isPegPactExpired: boolean;
  selectedLetter!: AddLetterModel;
  dialogType: LetterDialogTypes;
  signOffDate: string;
  isRemoveSignoff: boolean;
  isUpdateSignoff: boolean;
  signatures: any[];
  selectedSignature: any;
  clientSignature: SignatureLetterModel;
  sectionName: string;
  engagementId: number;
  subModuleId: number;
  engagementTemplateId: number;
  timeZoneData: UserTimeZoneModel
  selectedFirmLetter: any;
  selectedMasterLetter: any;
  configuration: ComponentConfigModel;
  s3FilePath: string;
  isUpdatedConfig: boolean;
  isCancel: boolean;
  hasAppPortal: boolean;
  hasMobilePortal: boolean;
  hasClientSignElement: boolean;
  hasReviewInPlan: boolean;
  pdfPreviewContent: any;
  letters: LetterSectionModel[];
  engLetterInfo: Record<string, any>;
}
